import React, { useEffect, PropsWithChildren } from 'react';

import { utilities } from '~/common';
import { HubSpotForm } from '~/components';

const { scrollToElement, customHTMLTagsParser } = utilities;

interface Props {
  parsed_body: string;
}

export const ParseArticleBody: React.FC<PropsWithChildren<Props>> = ({ parsed_body }) => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash !== '') {
      scrollToElement(document.getElementsByName(hash.slice(1, hash.length))[0]);
    }
  }, []);

  const sectionedBody = customHTMLTagsParser(parsed_body, ['HubSpotFormEmbed']).map(section =>
    section.type === 'html' ? (
      <div
        data-testid="article-body"
        key={section.type}
        dangerouslySetInnerHTML={{
          __html: section.data,
        }}
      />
    ) : section.type === 'HubSpotFormEmbed' && !!section.data ? (
      <HubSpotForm
        style={{ display: 'flex', justifyContent: 'center' }}
        {...JSON.parse(section.data)}
        className="hubspot-form"
      />
    ) : null,
  );

  return <> {sectionedBody} </>;
};
